import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useLinkedInAdGroupSettingsStyles = makeStyles({
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '836px',
    ...shorthands.gap(tokens.spacingVerticalS),
  },
});
